import React from 'react';
import { useFormContext } from 'react-hook-form';
import styled from '@emotion/styled';
import { BsX } from '@react-icons/all-files/bs/BsX';
import { Textarea } from '@bucketplace/commerce-admin-ui';
import { ODS_FONT_STYLE, ZINDEX } from '@bucketplace/design-system';

import { useDynamicLottiePlayer } from '@/hooks/useDynamicLottiePlayer';

interface LottiePreviewProps {
  name: string;
}

export function LottiePreview({ name }: LottiePreviewProps) {
  const { watch, setValue } = useFormContext();
  const src = watch(name) || [];
  const LottiePlayer = useDynamicLottiePlayer();

  const handleDelete = () => {
    setValue(name, null);
  };

  return (
    <>
      <Preview>
        { LottiePlayer && (
          <LottiePlayer
            src={src}
            autoplay
            loop
            style={{ fontSize: 0 }}
          />
        ) }
        <DeleteButton onClick={handleDelete}>
          <BsX />
        </DeleteButton>
      </Preview>
      <URLTextarea value={src} autoHeight readOnly />
    </>
  );
}

const Preview = styled.div`
  position: relative;
  width: 120px;
  margin-bottom: 4px;
  border: 1px solid ${({ theme }) => theme.base.neutral400};
`;

const DeleteButton = styled.button`
  && {
    position: absolute;
    top: -9px;
    right: -9px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    padding: 2px;
    border: 0;
    border-radius: 100%;
    background: rgba(0, 0, 0, 0.7);
    z-index: ${ZINDEX.dropdown};
    color: ${({ theme }) => theme.base.neutral100};
    &:hover {
      background: rgba(0, 0, 0, 0.9);
      transform: scale(1.1);
      transition: all 0.2s;
    }
  }
`;

const URLTextarea = styled(Textarea)`
  > textarea {
    ${ODS_FONT_STYLE.detail11L14};
  }
`;
